import React from "react";
import { Link } from "react-router-dom";

const StatisticsCard = ({ img, title, value, url }) => {
  return (
    <>
      <div className="relative flex flex-col bg-white shadow-sm border border-slate-200 rounded-lg w-[100%] xl:w-[33%] px-6 pt-6">
        <Link to={url}>
          <div className="absolute top-0 right-0 bg-[--primary] w-18 h-18 p-2 rounded-md flex justify-center items-center">
            <img src={img} alt={title} className="w-8 h-8" />
          </div>
          <div>
            <h4 className="font-normal leading-snug tracking-normal text-slate-800 mx-auto w-full sm:text-md max-w-md lg:max-w-xl text-sm">
              {title}
            </h4>
            <h4 className="SmoochSans-fontFamily font-semibold leading-snug tracking-normal text-slate-800 mx-auto w-full text-8xl max-w-md lg:max-w-xl ">
              {value || 0}
            </h4>
          </div>
        </Link>
      </div>
    </>
  );
};

export default StatisticsCard;
